import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import { BackResponse, FileSummary } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files/customerfile/${COMMON_QUERY_PARAMS.FILE_ID}/summary`;

export interface GetCustomerFileFullSummaryQueryArgs {
  fileId: string;
}

export const getCustomerFileFullSummaryRequest = (
  payload: GetCustomerFileFullSummaryQueryArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, payload.fileId),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getCustomerFileFullSummaryQuery = async (
  payload: GetCustomerFileFullSummaryQueryArgs,
) => {
  try {
    return await executeQuery<BackResponse<FileSummary>>(
      getCustomerFileFullSummaryRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
